var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Col',{staticClass:"setting_ps px-7 py-4 mt-2",attrs:{"id":"show-domain-fields-container"}},[_c('Col',{staticClass:"field-settings",attrs:{"cols":"12"}},[_c('h2',{staticClass:"settings-title"},[_vm._v("Transactional Emails")]),_c('AppTabs',{staticClass:"app-tabs pt-7",attrs:{"tabItems":_setup.tabItems}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }